import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import BootstrapModalOutletContainer from './modal/BootstrapModalOutletContainer';
import UIService from './AppUIService';
let _ = require('lodash');

class App extends Component {

  uiService: UIService;
  
  constructor(props) {
    super(props);

    this.goTo = this.goTo.bind(this);

    this.uiService = new UIService();
    this.state = {};
  }

  goTo(e) {
    let path = e.target.getAttribute('data-path');
    if (path === 'left-nav') {
      if (this.state.currentRoute.indexOf('search') !== -1) {
        browserHistory.push('/gallery');
      } else {
        browserHistory.push('/search');
      }
    } else if (path === 'right-nav') {
      if (this.state.currentRoute.indexOf('favorites') !== -1) {
        browserHistory.push('/gallery');
      } else {
        browserHistory.push('/favorites');
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.adjustUIRequired) {
      this.adjustUI();
    }
    this.setState({
      currentRoute: this.props.location.pathname
    })
  }

  adjustUI() {
      this.uiService.resetHeaderFooter();
      this.props.dispatchWindowResizedEvent();
      let currentPage = this.props.location.pathname;
      let imagesPage = false;
      let numImagesOnPage = 0;
      if (currentPage.indexOf('gallery') !== -1 || currentPage.indexOf('favorites') !== -1) {
        imagesPage = true;
        if (currentPage.indexOf('gallery') !== -1) {
          numImagesOnPage = this.props.photos.length;
        } else {
          numImagesOnPage = this.props.favoredPhotos.length;
        }
      }
      setTimeout(() => {
        this.uiService.adjustImageContainerHeights(imagesPage, numImagesOnPage);
      }, 100);
      this.props.dispatchCompletedAdjustUI();
  }

  componentDidMount() {
    window.onresize = _.debounce(() => {
      this.adjustUI();
    }, 300, {leading: false, trailing: true});

    window.addEventListener('orientationchange', () => {
      this.adjustUI();
    });

    window.onscroll = () => {
        this.uiService.adjustHeaderFooter();
    };

    this.props.dispatchWindowResizedEvent();
    browserHistory.push('/search');
  }

  render() {
    return (      
        <div>
          <nav id="nav-menu">
            <div onClick={this.goTo} data-path="left-nav" className="nav-item">{this.state.currentRoute && this.state.currentRoute.indexOf('search') !== -1 ? 'Gallery' : 'Search'}</div><div onClick={this.goTo} data-path="right-nav" className="nav-item">{this.state.currentRoute && this.state.currentRoute.indexOf('favorites') !== -1 ? 'Gallery' : 'Favorites'}</div>
          </nav>
          {this.props.children}
          <footer className="footer">React & Redux Flickr photos app by Daniel Chermetz</footer>
          <BootstrapModalOutletContainer></BootstrapModalOutletContainer>
        </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/